import {
  FastApiErrorResponse,
  FastApiValidationDetail,
} from "./registrationRequest";

export type NotificationDeliveryStatus = "PENDING" | "SENT" | "FAILED";
export type FaleConoscoSubmitterType = "VISITOR" | "AUTHENTICATED";

export interface ContactRequestInput {
  fullName: string;
  email: string;
  message: string;
  lgpdConsent: boolean;
}

export interface ContactRequestPayload {
  full_name: string;
  email: string;
  message: string;
  lgpd_consent: boolean;
}

export interface PlatformEvaluationInput {
  fullName?: string | null;
  email?: string | null;
  generalExperienceRating: number;
  informationRelevanceRating: number;
  crossingEaseRating: number;
  reportClarityRating: number;
  planningSupportRating: number;
  institutionalUsefulnessRating: number;
  lgpdConsent: boolean;
}

export interface PlatformEvaluationPayload {
  full_name?: string | null;
  email?: string | null;
  general_experience_rating: number;
  information_relevance_rating: number;
  crossing_ease_rating: number;
  report_clarity_rating: number;
  planning_support_rating: number;
  institutional_usefulness_rating: number;
  lgpd_consent: boolean;
}

interface FaleConoscoBaseResponse {
  id: number;
  submitter_type: FaleConoscoSubmitterType;
  notification_delivery_status: NotificationDeliveryStatus;
  notification_sent_at?: string | null;
  notification_error?: string | null;
  created_at: string;
  updated_at: string;
}

export interface ContactRequestResponse
  extends FaleConoscoBaseResponse,
    ContactRequestPayload {}

export interface PlatformEvaluationResponse
  extends FaleConoscoBaseResponse,
    PlatformEvaluationPayload {}

export type FaleConoscoErrorCode =
  | "CONFLICT"
  | "VALIDATION"
  | "DELIVERY_FAILED"
  | "NETWORK"
  | "UNKNOWN";

export class FaleConoscoServiceError extends Error {
  constructor(
    public readonly code: FaleConoscoErrorCode,
    message: string,
    public readonly status?: number,
    public readonly validationDetails: FastApiValidationDetail[] = []
  ) {
    super(message);
    this.name = "FaleConoscoServiceError";
  }
}

export type FaleConoscoFastApiErrorResponse = FastApiErrorResponse;
